import { MedicalIcon } from "@/components/flutter-asset/medical-icon";
import { useI18n } from "@/utils/i18n";
import type { ReactNode } from "react";
import styles from "./modal-frame.module.css";

export function ModalFrame({
  title,
  subtitle,
  children,
  onClose,
  className = "",
  hideCloseIcon = false,
  footer,
  dimBackdrop = true,
  closeOnBackdrop = false,
}: {
  title: string;
  subtitle?: string;
  children: ReactNode;
  onClose: () => void;
  className?: string;
  hideCloseIcon?: boolean;
  footer?: ReactNode;
  dimBackdrop?: boolean;
  closeOnBackdrop?: boolean;
}) {
  const { t } = useI18n();
  const backdropClassName = [styles.modalBackdrop, dimBackdrop ? null : styles.transparent]
    .filter(Boolean)
    .join(" ");
  const modalClassName = [styles.modal, className].filter(Boolean).join(" ");

  return (
    <div
      className={backdropClassName}
      role="dialog"
      aria-modal="true"
      onClick={closeOnBackdrop ? onClose : undefined}
    >
      <section
        className={modalClassName}
        onClick={(event) => event.stopPropagation()}
      >
        <div className={styles.modalHeader}>
          <div className={styles.modalTitleRow}>
            <h2>{title}</h2>
            {hideCloseIcon ? null : (
              <button className={styles.iconButton} type="button" aria-label={t("common.close")} onClick={onClose}>
                <MedicalIcon className={styles.closeIcon} name="cancel" />
              </button>
            )}
          </div>
          {subtitle ? <p className={styles.modalSubtitle}>{subtitle}</p> : null}
        </div>
        {children}
        {footer}
      </section>
    </div>
  );
}
